"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Import styles
require("../scss/pickr.scss");
// Import utils
var _ = require("./utils/utils");
var Color = require("./utils/color");
// Import classes
var hsvacolor_1 = require("./utils/hsvacolor");
var moveable_1 = require("./libs/moveable");
var selectable_1 = require("./libs/selectable");
var nanopop_1 = require("./libs/nanopop");
var template_1 = require("./template");
var Pickr = /** @class */ (function () {
    function Pickr(opt) {
        var _this = this;
        // Will be used to prevent specific actions during initilization
        this._initializingActive = true;
        // Replace element with color picker
        this._recalc = true;
        // Current and last color for comparison
        this._color = hsvacolor_1.HSVaColor();
        this._lastColor = hsvacolor_1.HSVaColor();
        this._swatchColors = [];
        // Evenlistener name: [callbacks]
        this._eventListener = {
            'swatchselect': [],
            'change': [],
            'save': [],
            'init': []
        };
        // Assign default values
        this.options = opt = Object.assign({
            appClass: null,
            useAsButton: false,
            disabled: false,
            comparison: true,
            components: {
                interaction: {}
            },
            strings: {},
            swatches: null,
            inline: false,
            default: '#42445A',
            defaultRepresentation: null,
            position: 'bottom-middle',
            adjustableNumbers: true,
            showAlways: false,
            closeWithKey: 'Escape'
        }, opt);
        var swatches = opt.swatches, inline = opt.inline, components = opt.components, position = opt.position;
        // Check interaction section
        if (!components.interaction) {
            components.interaction = {};
        }
        // Overwrite palette if preview, opacity or hue are true
        var preview = components.preview, opacity = components.opacity, hue = components.hue, palette = components.palette;
        components.palette = palette || preview || opacity || hue;
        // Per default enabled if inline
        if (inline) {
            opt.showAlways = true;
        }
        // Initialize picker
        this._preBuild();
        this._buildComponents();
        this._bindEvents();
        // Finalize build
        this._finalBuild();
        // Append pre-defined swatch colors
        if (swatches && swatches.length) {
            swatches.forEach(function (color) { return _this.addSwatch(color); });
        }
        // Initialize positioning engine
        this._nanopop = nanopop_1.default({
            reference: this._root.button,
            el: this._root.app,
            pos: position
        });
        // Initilization is finish, pickr is visible and ready for usage
        var button = this._root.button;
        var that = this;
        requestAnimationFrame((function cb() {
            // offsetParent of body is always 0. So check if it is the body
            if (button.offsetParent === null && button !== document.body) {
                return requestAnimationFrame(cb);
            }
            // Apply default color
            that.setColor(opt.default);
            that._rePositioningPicker();
            // Initialize color representation
            if (opt.defaultRepresentation) {
                that._representation = opt.defaultRepresentation;
                that.setColorRepresentation(that._representation);
            }
            // Show pickr if locked
            if (opt.showAlways) {
                that.show();
            }
            // Initialization is done - pickr is usable, fire init event
            that._initializingActive = false;
            that._emit('init');
        }));
    }
    // Does only the absolutly basic thing to initialize the components
    Pickr.prototype._preBuild = function () {
        var opt = this.options;
        // Check if element is selector
        if (typeof opt.el === 'string') {
            // Resolve possible shadow dom access
            opt.el = opt.el.split(/>>/g).reduce(function (pv, cv, ci, a) {
                pv = pv.querySelector(cv);
                return ci < a.length - 1 ? pv.shadowRoot : pv;
            }, document);
        }
        // Create element and append it to body to
        // prevent initialization errors
        this._root = template_1.default(opt);
        // Check if a custom button is used
        if (opt.useAsButton) {
            this._root.button = opt.el; // Replace button with customized button
        }
        document.body.appendChild(this._root.root);
    };
    Pickr.prototype._finalBuild = function () {
        var opt = this.options;
        var root = this._root;
        // Remove from body
        document.body.removeChild(root.root);
        //if (opt.inline) {
        var parentElement = opt.el.parentElement;
        if (parentElement.lastChild === opt.el) {
            parentElement.appendChild(root.app);
        }
        else {
            parentElement.insertBefore(root.app, opt.el.nextSibling);
        }
        // } else {
        //     document.body.appendChild(root.app);
        // }
        // Don't replace the the element if a custom button is used
        if (!opt.useAsButton) {
            // Replace element with actual color-picker
            opt.el.parentNode.replaceChild(root.root, opt.el);
        }
        // Call disable to also add the disabled class
        if (opt.disabled) {
            this.disable();
        }
        // Check if color comparison is disabled, if yes - remove transitions so everything keeps smoothly
        if (!opt.comparison) {
            root.button.style.transition = 'none';
            if (!opt.useAsButton) {
                root.preview.lastColor.style.transition = 'none';
            }
        }
        this.hide();
    };
    Pickr.prototype._buildComponents = function () {
        // Instance reference
        var inst = this;
        var comp = this.options.components;
        var components = {
            palette: moveable_1.default({
                element: inst._root.palette.picker,
                wrapper: inst._root.palette.palette,
                onchange: function (x, y) {
                    if (!comp.palette)
                        return;
                    var _color = inst._color, _root = inst._root, options = inst.options;
                    // Calculate saturation based on the position
                    _color.s = (x / this.wrapper.offsetWidth) * 100;
                    // Calculate the value
                    _color.v = 100 - (y / this.wrapper.offsetHeight) * 100;
                    // Prevent falling under zero
                    _color.v < 0 ? _color.v = 0 : 0;
                    // Set picker and gradient color
                    var cssRGBaString = _color.toRGBA().toString();
                    this.element.style.background = cssRGBaString;
                    this.wrapper.style.background = "\n                        linear-gradient(to top, rgba(0, 0, 0, " + _color.a + "), transparent),\n                        linear-gradient(to left, hsla(" + _color.h + ", 100%, 50%, " + _color.a + "), rgba(255, 255, 255, " + _color.a + "))\n                    ";
                    // Check if color is locked
                    if (!options.comparison) {
                        _root.button.style.color = cssRGBaString;
                        if (!options.useAsButton) {
                            _root.preview.lastColor.style.color = cssRGBaString;
                        }
                    }
                    // Change current color
                    _root.preview.currentColor.style.color = cssRGBaString;
                    // Update the input field only if the user is currently not typing
                    if (inst._recalc) {
                        inst._updateOutput();
                    }
                    // If the user changes the color, remove the cleared icon
                    _root.button.classList.remove('clear');
                }
            }),
            hue: moveable_1.default({
                lockX: true,
                element: inst._root.hue.picker,
                wrapper: inst._root.hue.slider,
                onchange: function (x, y) {
                    if (!comp.hue || !comp.palette)
                        return;
                    // Calculate hue
                    inst._color.h = (y / this.wrapper.offsetHeight) * 360;
                    // Update color
                    this.element.style.backgroundColor = "hsl(" + inst._color.h + ", 100%, 50%)";
                    components.palette.trigger();
                }
            }),
            opacity: moveable_1.default({
                lockX: true,
                element: inst._root.opacity.picker,
                wrapper: inst._root.opacity.slider,
                onchange: function (x, y) {
                    if (!comp.opacity || !comp.palette)
                        return;
                    // Calculate opacity
                    inst._color.a = Math.round(((y / this.wrapper.offsetHeight)) * 1e2) / 100;
                    // Update color
                    this.element.style.background = "rgba(0, 0, 0, " + inst._color.a + ")";
                    inst.components.palette.trigger();
                }
            }),
            selectable: selectable_1.default({
                elements: inst._root.interaction.options,
                className: 'active',
                onchange: function (e) {
                    inst._representation = e.target.getAttribute('data-type').toUpperCase();
                    inst._updateOutput();
                }
            })
        };
        this.components = components;
    };
    Pickr.prototype._bindEvents = function () {
        var _this = this;
        var _a = this, _root = _a._root, options = _a.options;
        var eventBindings = [
            // Clear color
            _.on(_root.interaction.clear, 'click', function () { return _this._clearColor(); }),
            // Select last color on click
            _.on(_root.preview.lastColor, 'click', function () { return _this.setHSVA.apply(_this, _this._lastColor.toHSVA()); }),
            // Save color
            _.on(_root.interaction.save, 'click', function () {
                !_this.applyColor() && !options.showAlways && _this.hide();
            }),
            // Detect user input and disable auto-recalculation
            _.on(_root.interaction.result, ['keyup', 'input'], function (e) {
                _this._recalc = false;
                // Fire listener if initialization is finish and changed color was valid
                if (_this.setColor(e.target.value, true) && !_this._initializingActive) {
                    _this._emit('change', _this._color);
                }
                e.stopImmediatePropagation();
            }),
            // Cancel input detection on color change
            _.on([
                _root.palette.palette,
                _root.palette.picker,
                _root.hue.slider,
                _root.hue.picker,
                _root.opacity.slider,
                _root.opacity.picker
            ], ['mousedown', 'touchstart'], function () { return _this._recalc = true; })
        ];
        // Provide hiding / showing abilities only if showAlways is false
        if (!options.showAlways) {
            var ck_1 = options.closeWithKey;
            eventBindings.push(
            // Save and hide / show picker
            _.on(_root.button, 'click', function () { return _this.isOpen() ? _this.hide() : _this.show(); }), 
            // Close with escape key
            _.on(document, 'keyup', function (e) { return _this.isOpen() && (e.key === ck_1 || e.code === ck_1) && _this.hide(); }), 
            // Cancel selecting if the user taps behind the color picker
            _.on(document, ['touchstart', 'mousedown'], function (e) {
                if (_this.isOpen() && !_.eventPath(e).some(function (el) { return el === _root.app || el === _root.button; })) {
                    _this.hide();
                }
            }, { capture: true }));
        }
        // Make input adjustable if enabled
        if (options.adjustableNumbers) {
            _.adjustableInputNumbers(_root.interaction.result, false);
        }
        if (!options.inline) {
            var timeout_1 = null;
            var that_1 = this;
            // Re-calc position on window resize, scroll and wheel
            eventBindings.push(_.on(window, ['scroll', 'resize'], function () {
                if (that_1.isOpen()) {
                    if (timeout_1 === null) {
                        timeout_1 = setTimeout(function () { return timeout_1 = null; }, 100);
                        // Update position on every frame
                        requestAnimationFrame(function rs() {
                            that_1._rePositioningPicker();
                            (timeout_1 !== null) && requestAnimationFrame(rs);
                        });
                    }
                    else {
                        clearTimeout(timeout_1);
                        timeout_1 = setTimeout(function () { return timeout_1 = null; }, 100);
                    }
                }
            }));
        }
        // Save bindings
        this._eventBindings = eventBindings;
    };
    Pickr.prototype._rePositioningPicker = function () {
        // No repositioning needed if inline
        if (!this.options.inline) {
            this._nanopop.update();
        }
    };
    Pickr.prototype._updateOutput = function () {
        // Check if component is present
        if (this._root.interaction.type()) {
            // Construct function name and call if present
            var method = "to" + this._root.interaction.type().getAttribute('data-type');
            this._root.interaction.result.value = typeof this._color[method] === 'function' ? this._color[method]().toString() : '';
        }
        // Fire listener if initialization is finish
        if (!this._initializingActive) {
            this._emit('change', this._color);
        }
    };
    Pickr.prototype._clearColor = function () {
        var _a = this, _root = _a._root, options = _a.options;
        // Change only the button color if it isn't customized
        if (!options.useAsButton) {
            _root.button.style.color = 'rgba(0, 0, 0, 0.15)';
        }
        _root.button.classList.add('clear');
        if (!options.showAlways) {
            this.hide();
        }
        if (!this._initializingActive) {
            // Fire listener
            this._emit('save', null);
        }
    };
    Pickr.prototype._emit = function (event) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this._eventListener[event].forEach(function (cb) { return cb.apply(void 0, args.concat([_this])); });
    };
    Pickr.prototype.on = function (event, cb) {
        // Validate
        if (typeof cb === 'function' && typeof event === 'string' && event in this._eventListener) {
            this._eventListener[event].push(cb);
        }
        return this;
    };
    Pickr.prototype.off = function (event, cb) {
        var callBacks = this._eventListener[event];
        if (callBacks) {
            var index = callBacks.indexOf(cb);
            if (~index) {
                callBacks.splice(index, 1);
            }
        }
        return this;
    };
    /**
     * Appends a color to the swatch palette
     * @param color
     * @returns {boolean}
     */
    Pickr.prototype.addSwatch = function (color) {
        var _this = this;
        var values = Color.parseToHSV(color).values;
        if (values) {
            var _a = this, _swatchColors = _a._swatchColors, _root = _a._root;
            var hsvaColorObject_1 = hsvacolor_1.HSVaColor.apply(void 0, values);
            // Create new swatch HTMLElement
            var element = _.createElementFromString("<button type=\"button\" style=\"color: " + hsvaColorObject_1.toRGBA() + "\"></button>");
            // Append element and save swatch data
            _root.swatches.appendChild(element);
            _swatchColors.push({ element: element, hsvaColorObject: hsvaColorObject_1 });
            // Bind event
            this._eventBindings.push(_.on(element, 'click', function () {
                _this.setHSVA.apply(_this, hsvaColorObject_1.toHSVA().concat([true]));
                _this._emit('swatchselect', hsvaColorObject_1);
            }));
            return true;
        }
        return false;
    };
    /**
     * Removes a swatch color by it's index
     * @param index
     * @returns {boolean}
     */
    Pickr.prototype.removeSwatch = function (index) {
        // Validate index
        if (typeof index === 'number') {
            var swatchColor = this._swatchColors[index];
            // Check swatch data
            if (swatchColor) {
                var element = swatchColor.element;
                // Remove HTML child and swatch data
                this._root.swatches.removeChild(element);
                this._swatchColors.splice(index, 1);
                return true;
            }
        }
        return false;
    };
    Pickr.prototype.applyColor = function (silent) {
        if (silent === void 0) { silent = false; }
        var _a = this._root, preview = _a.preview, button = _a.button;
        // Change preview and current color
        var cssRGBaString = this._color.toRGBA().toString();
        preview.lastColor.style.color = cssRGBaString;
        // Change only the button color if it isn't customized
        if (!this.options.useAsButton) {
            button.style.color = cssRGBaString;
        }
        // User changed the color so remove the clear clas
        button.classList.remove('clear');
        // Save last color
        this._lastColor = this._color.clone();
        // Fire listener
        if (!this._initializingActive && !silent) {
            this._emit('save', this._color);
        }
    };
    /**
     * Destroy's all functionalitys
     */
    Pickr.prototype.destroy = function () {
        var _this = this;
        this._eventBindings.forEach(function (args) { return _.off.apply(_, args); });
        Object.keys(this.components).forEach(function (key) { return _this.components[key].destroy(); });
    };
    /**
     * Destroy's all functionalitys and removes
     * the pickr element.
     */
    Pickr.prototype.destroyAndRemove = function () {
        this.destroy();
        // Remove element
        var root = this._root.root;
        root.parentElement.removeChild(root);
        // remove .pcr-app
        var app = this._root.app;
        app.parentElement.removeChild(app);
        // There are references to various DOM elements stored in the pickr instance
        // This cleans all of them to avoid detached DOMs
        var pickr = this;
        Object.keys(pickr).forEach(function (key) { return pickr[key] = null; });
    };
    /**
     * Hides the color-picker ui.
     */
    Pickr.prototype.hide = function () {
        this._root.app.classList.remove('visible');
        return this;
    };
    /**
     * Shows the color-picker ui.
     */
    Pickr.prototype.show = function () {
        if (this.options.disabled)
            return;
        this._root.app.classList.add('visible');
        this._rePositioningPicker();
        return this;
    };
    /**
     * @return {boolean} If the color picker is currently open
     */
    Pickr.prototype.isOpen = function () {
        return this._root.app.classList.contains('visible');
    };
    /**
     * Set a specific color.
     * @param h Hue
     * @param s Saturation
     * @param v Value
     * @param a Alpha channel (0 - 1)
     * @param silent If the button should not change the color
     * @return boolean if the color has been accepted
     */
    Pickr.prototype.setHSVA = function (h, s, v, a, silent) {
        if (h === void 0) { h = 360; }
        if (s === void 0) { s = 0; }
        if (v === void 0) { v = 0; }
        if (a === void 0) { a = 1; }
        if (silent === void 0) { silent = false; }
        // Deactivate color calculation
        var recalc = this._recalc; // Save state
        this._recalc = false;
        // Validate input
        if (h < 0 || h > 360 || s < 0 || s > 100 || v < 0 || v > 100 || a < 0 || a > 1) {
            return false;
        }
        // Override current color and re-active color calculation
        this._color = hsvacolor_1.HSVaColor(h, s, v, a);
        // Short names
        var _a = this.components, hue = _a.hue, opacity = _a.opacity, palette = _a.palette;
        // Calculate y position of hue slider
        var hueWrapper = hue.options.wrapper;
        var hueY = hueWrapper.offsetHeight * (h / 360);
        hue.update(0, hueY);
        // Calculate y position of opacity slider
        var opacityWrapper = opacity.options.wrapper;
        var opacityY = opacityWrapper.offsetHeight * a;
        opacity.update(0, opacityY);
        // Calculate y and x position of color palette
        var pickerWrapper = palette.options.wrapper;
        var pickerX = pickerWrapper.offsetWidth * (s / 100);
        var pickerY = pickerWrapper.offsetHeight * (1 - (v / 100));
        palette.update(pickerX, pickerY);
        // Restore old state
        this._recalc = recalc;
        // Update output if recalculation is enabled
        if (this._recalc) {
            this._updateOutput();
        }
        // Check if call is silent
        if (!silent) {
            this.applyColor();
        }
        return true;
    };
    /**
     * Tries to parse a string which represents a color.
     * Examples: #fff
     *           rgb 10 10 200
     *           hsva 10 20 5 0.5
     * @param string
     * @param silent
     */
    Pickr.prototype.setColor = function (string, silent) {
        if (silent === void 0) { silent = false; }
        // Check if null
        if (string === null) {
            this._clearColor();
            return true;
        }
        var _a = Color.parseToHSV(string), values = _a.values, type = _a.type;
        // Check if color is ok
        if (values) {
            // Change selected color format
            var utype_1 = type.toUpperCase();
            var options = this._root.interaction.options;
            var target = options.find(function (el) { return el.getAttribute('data-type').startsWith(utype_1); });
            // Auto select only if not hidden
            if (target && !target.hidden) {
                for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
                    var el = options_1[_i];
                    el.classList[el === target ? 'add' : 'remove']('active');
                }
            }
            return this.setHSVA.apply(this, values.concat([silent]));
        }
    };
    /**
     * Changes the color _representation.
     * Allowed values are HEX, RGB, HSV, HSL and CMYK
     * @param type
     * @returns {boolean} if the selected type was valid.
     */
    Pickr.prototype.setColorRepresentation = function (type) {
        // Force uppercase to allow a case-sensitiv comparison
        type = type.toUpperCase();
        // Find button with given type and trigger click event
        return !!this._root.interaction.options.find(function (v) { return v.getAttribute('data-type').startsWith(type) && !v.click(); });
    };
    /**
     * Returns the current color representaion. See setColorRepresentation
     * @returns {*}
     */
    Pickr.prototype.getColorRepresentation = function () {
        return this._representation;
    };
    /**
     * @returns HSVaColor Current HSVaColor object.
     */
    Pickr.prototype.getColor = function () {
        return this._color;
    };
    /**
     * @returns The root HTMLElement with all his components.
     */
    Pickr.prototype.getRoot = function () {
        return this._root;
    };
    /**
     * Disable pickr
     */
    Pickr.prototype.disable = function () {
        this.hide();
        this.options.disabled = true;
        this._root.button.classList.add('disabled');
        return this;
    };
    /**
     * Enable pickr
     */
    Pickr.prototype.enable = function () {
        this.options.disabled = false;
        this._root.button.classList.remove('disabled');
        return this;
    };
    return Pickr;
}());
// Expose pickr utils
Pickr.utils = _;
// Create instance via method
Pickr.create = function (options) { return new Pickr(options); };
// Assign version and export
Pickr.version = '0.6.2';
exports.default = Pickr;
